/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Location",
  size: 20
}

const SvgLocation = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path
      fill="none"
      strokeWidth={1.01}
      d="M10 .5C6.41.5 3.5 3.39 3.5 6.98 3.5 11.83 10 19 10 19s6.5-7.17 6.5-12.02C16.5 3.39 13.59.5 10 .5h0z"
    />
    <circle fill="none" cx={10} cy={6.8} r={2.3} />
  </Svg>
)

SvgLocation.defaultProps = defaultProps
export default SvgLocation
